module.exports = __webpack_public_path__ + "media/images/icons/icon_close-875b3baff89c8353f4c33265511195bc.png";